module.exports = __webpack_public_path__ + "static/media/LoginIn.0df56967.svg";